import type { FragmentOf } from "@opensea/graphql"
import { readFragment } from "@opensea/graphql"
import { getCollectionSweepQuoteErrorFragment } from "./getCollectionSweepQuoteError.fragment"

export function getCollectionSweepQuoteError(
  fragment: FragmentOf<typeof getCollectionSweepQuoteErrorFragment>,
) {
  const quote = readFragment(getCollectionSweepQuoteErrorFragment, fragment)
  switch (quote.__typename) {
    case "CollectionSweepQuoteNotFound":
      return "No items found for sweep. Try increasing max price per item."
    default:
      return undefined
  }
}
